const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

/**
 * Edit Polls Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Polls} Polls injected to gain access to the Polls resource
 */
app.controller('editPoll', ['Application', 'Authorization', 'Polls', 'Analyze', 'Viewables', '$scope', '$translate', function(Application, Authorization, Polls, Analyze, Viewables, $scope, $translate) {
    var self = this;
    var routeParameters = Application.navigation.getRouteParameters();
    Application.scrollTop();
    self.user = Authorization.getAuthToken().user;
    self.showCollaborators = false;
    self.info = {
      newPoll: routeParameters.id === 'new' ? true : routeParameters.id ? false : true,
      user: self.user,
      fields: 'company,user,question,answers,expiration,anonymous_results,show_results,private,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,published,explore_hide,title,author,image,tags,response_copy,cover_justification,featured_justification,emojis,emoji_type,background_color',
      updateIndicator: false,
      promptPublish: false,
      activeTab: 'details',
      initializing: false,
      states: [],
      colors: Application.colors.get().slice(0, 3),
      requiredFields: {title: true, question: true, answers: true},
      expirationDate: null,
      expirationTime: null,
      defaultPoll: function() {
        return {
          question: '',
          answers: [{label: '', value: 'a'}, {label: '', value: 'b'}],
          expiration: new Date(moment().add(14, 'days').calendar()),
          anonymous_results: false,
          show_results: true,
          private: false,
          privacy_collaborators: [],
          privacy_locations: [],
          privacy_departments: [],
          linked_category: [],
          published: false,
          explore_hide: false,
          emojis: false,
          background_color: self.info.colors[0],
          title: '',
          author: '',
          image: '',
          tags: [],
          response_copy: '',
          cover_justification: '',
          featured_justification: ''
        };
      },
      timeFormatting: function() {
        var startTime = moment(new Date(self.poll.expiration).toISOString()).seconds(0).milliseconds(0);
        self.info.expirationDate = startTime.format('MM/DD/YY');
        self.info.expirationTime = new Date(startTime.toISOString());
      },
      timeCombining: function() {
        var momentStartTime = moment(self.info.expirationTime.toISOString());
        var combStart = moment(new Date(self.info.expirationDate).toISOString()).hours(momentStartTime.hours()).minutes(momentStartTime.minutes()).seconds(0).milliseconds(0);
        self.poll.expiration = new Date(combStart.toISOString());
      },
      previousAnswers: null,
      changeType: function(type) {
        if (self.poll.published) {
          return;
        }
        if (type === 'emojis') {
          if (!self.poll.emojis) {
            this.previousAnswers = self.poll.answers ? JSON.parse(JSON.stringify(self.poll.answers)) : [{label: '', value: 'a'}, {label: '', value: 'b'}];
          }
          self.poll.emojis = true;
          self.poll.emoji_type = 'hands';
          self.poll.answers = [{label: '&#x1F44D;', value: 'a'}, {label: '&#x1F44E;', value: 'b'}];
          return;
        }
        if (self.poll.emojis) {
          self.poll.answers = this.previousAnswers ? this.previousAnswers : [{label: '', value: 'a'}, {label: '', value: 'b'}];
        }
        self.poll.emojis = false;
      },
      selectEmojiType: function(type) {
        if (self.poll.published) {
          return;
        }
        self.poll.emoji_type = type;
        if (type === 'hands') {
          self.poll.answers = [{label: '&#x1F44D;', value: 'a'}, {label: '&#x1F44E;', value: 'b'}];
        }
        if (type === 'faces') {
          self.poll.answers = [{label: '&#x1F642;', value: 'a'}, {label: '&#x1F610;', value: 'b'}, {label: '&#x1F641;', value: 'c'}];
        }
      },
      getBg: function(color) {
        return {'background-color': color};
      },
      chooseBackground: function(color) {
        self.poll.background_color = color;
        self.comms.blurSave('background_color');
      }
    };

    self.navigation = {
      denied: false,
      backLocation: Application.navigation.history[Application.navigation.history.length - 2],
      displayLeaveConfirm: false,
      goBack: function() {
        if (!this.denied || !this.backLocation) {
          Application.navigation.back();
          this.denied = true;
          return;
        }
        this.denied = true;
        var location = this.backLocation.split('/#/');
        if (location.length !== 2) {
          Application.navigation.back();
          return;
        }
        Application.navigation.goTo(location[1]);
      },
      directory: {
        'details': {
          next: 'background',
          previous: null,
          required: ['title', 'question', 'answers']
        },
        'background': {
          next: 'categories',
          previous: 'details',
          required: null
        },
        'categories': {
          next: 'settings',
          previous: 'background',
          required: null
        },
        'settings': {
          next: null,
          previous: 'categories',
          required: null
        }
      },
      nextSection: function(item) {
        var nextClicked = true;
        var item = item ? self.navigation.directory[item].previous : self.info.activeTab;
        var next = self.navigation.directory[item].next;
        var missing = '';
        var allow = true;

        var findIssues = function(check) {
          var current = self.navigation.directory[check];
          if (current.required) {
            for (var i = 0; i < current.required.length; i++) {
              if (current.required[i] === 'answers') {
                if (!self.poll[current.required[i]] || !self.poll[current.required[i]].length) {
                  allow = false;
                  missing = missing + ' ' + current.required[i] + ',';
                  continue;
                }
              }

              if (!self.poll[current.required[i]]) {
                allow = false;
                missing = missing + ' ' + current.required[i] + ',';
              }
            }
          }
          if (current.previous) {
            findIssues(current.previous);
          }
        };

        findIssues(item);

        if (allow && next) {
          self.info.activeTab = next;
          Application.scrollTop();
          return;
        }

        if (missing) {
          Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
        }
      }
    };

    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (!self.info.newPoll || self.info.newPoll === 'created') {

        // Allow the route change to progress
        self.navigation.denied = true;
        return;
      }

      // Halt the route change and question the action
      self.navigation.path = {};
      self.navigation.path.targetPath = Application.navigation.getPath();
      self.navigation.path.targetSearch = Application.navigation.getUrlParameters();
      self.navigation.path.targetHash = Application.navigation.getHash();
      event.preventDefault();
      self.navigation.displayLeaveConfirm = true;
      self.onLocationChange = function() {
        locationChange();
      };
    });

    self.answer = {
      options: ['a', 'b', 'c', 'd', 'e'],
      add: function() {
        if (self.poll.answers.length >= this.options.length) {
          return;
        }

        self.poll.answers.push({label: '', value: this.options[self.poll.answers.length]});
      },
      remove: function(answer) {
        var setRemoval;
        var itemIndex;
        var optionIndex = this.options.indexOf(answer.value);

        if (!optionIndex && optionIndex !== 0) {
          return;
        }

        if (self.poll.answers.length <= 2) {
          return;
        }

        for (var i = 0; i < self.poll.answers.length; i++) {
          if (answer.value === self.poll.answers[i].value) {
            setRemoval = i;
            continue;
          }
          itemIndex = this.options.indexOf(self.poll.answers[i].value);
          if (itemIndex > optionIndex) {
            self.poll.answers[i].value = this.options[itemIndex - 1];
          }
        }

        if (!setRemoval && setRemoval !== 0) {
          return;
        }

        self.poll.answers.splice(setRemoval, 1);

        self.comms.blurSave('answers');
      }
    };

    self.comms = {
      initialize: function() {
        if (!Authorization.hasValidAuthToken()) {
          if (Application.navigation.isRouteSecure()) {
            Application.navigation.goToSignIn();
          }
        }
        if (!Authorization.getAuthToken().company.engage) {
          Application.navigation.goToHome();
          return;
        }

        if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
          Application.navigation.goTo('/explore');
          return;
        }


        if (self.info.newPoll) {
          self.poll = self.info.defaultPoll();
          if (self.user.is_collaborator) {
            self.poll.privacy_collaborators.push(self.user._id);
          }
          self.info.timeFormatting();
          self.info.states.push(JSON.parse(JSON.stringify(self.poll)));
          watchDate();
          return;
        }
        self.info.updateIndicator = true;
        self.info.initializing = true;
        Polls.get({
          subresource: routeParameters.id,
          fields: self.info.fields
        }, function(data) {
          if ((data.company !== self.authtoken.company._id) || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.articleNotEditable'], duration: 5});
            locationChange();
            Application.navigation.goToHome();
          }
          self.poll = data;
          if (!self.poll.privacy_collaborators) {
            self.poll.privacy_collaborators = [];
          }
          if (self.poll.privacy_collaborators.length && !self.user.is_collaborator) {
            self.showCollaborators = true;
          }
          self.info.timeFormatting();
          self.info.states.push(JSON.parse(JSON.stringify(data)));
          watchDate();
          self.info.updateIndicator = false;
          setTimeout(function() {
            self.info.initializing = false;
          }, 100);
        }, function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['editPoll.unable_to_find_poll'], duration: 5});
          self.info.updateIndicator = false;
          self.info.initializing = false;
        });
      },
      create: function() {
        self.info.updateIndicator = true;
        self.poll.user = self.info.user._id;
        if(self.user.is_collaborator) {
          self.poll.approval_required = true;
          self.poll.approved = false;
        }
        Polls.create(self.poll).$promise
            .then(function(data) {
              self.poll = data;
              Analyze.record({resource: 'creations'}, {document: data._id, type: 'poll'});
              Application.analyticsProvider.trackEvent('poll_created', {content: data_id, content_type: 'poll', title: data.title});
              self.info.states.push(data);
              self.info.timeFormatting();
              self.info.newPoll = false;
              $translate('editPoll.poll_was_created', {title: data.title}).then(function(translation) {
                Application.messaging.addMessage({type: 'success', duration: 5, text: translation});
              });
              self.info.promptPublish = true;
              self.info.updateIndicator = false;
            }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['editPoll.unable_to_create'], duration: 5});
          self.info.updateIndicator = false;
        });
      },
      blurSave: function(field) {
        if (self.info.newPoll || self.info.initializing) {
          return;
        }

        var previousState = self.info.states[self.info.states.length - 1];

        if (field === 'expiration') {
          self.info.timeCombining();
          if (new Date(self.poll.expiration).valueOf() === new Date(previousState.expiration).valueOf()) {
            return;
          }
        }

        if (!self.info.defaultPoll().hasOwnProperty(field)) {
          return;
        }

        if (field !== 'private' && self.poll[field] === previousState[field]) {
          return;
        }

        if (!self.poll[field] && self.navigation.directory[self.info.activeTab].required && self.navigation.directory[self.info.activeTab].required.length) {
          if (self.navigation.directory[self.info.activeTab].required.indexOf(field) !== -1) {
            self.poll[field] = self.info.states[self.info.states.length - 1][field];
            return;
          }
        }

        if (field === 'answers') {
          var differentAnswer = false;
          for (var i = 0; i < self.poll.answers.length; i++) {
            if (!previousState.answers || !previousState.answers[i] || self.poll.answers.length !== previousState.answers.length) {
              differentAnswer = true;
              break;
            }
            if (self.poll.answers[i].value !== previousState.answers[i].value || self.poll.answers[i].label !== previousState.answers[i].label) {
              differentAnswer = true;
              break;
            }
          }
          if (!differentAnswer) {
            return;
          }
        }

        var body = {};
        body[field] = self.poll[field];

        if (field === 'private') {
          body.privacy_departments = self.poll.privacy_departments;
          body.privacy_locations = self.poll.privacy_locations;
          body.privacy_collaborators = self.poll.privacy_collaborators;
        }

        self.comms.save(body);
      },
      save: function(body) {
        if (!body) {
          return;
        }
        var expirationUpdate = body.expiration ? true : false;
        self.info.updateIndicator = true;
        if(self.user.is_collaborator) {
          self.poll.approval_required = true;
          self.poll.approved = false;
        }
        return Polls.update({subresource: self.poll._id, fields: self.info.fields}, body).$promise
            .then(function(data) {
              Analyze.record({resource: 'modifications'}, {document: self.poll._id, type: 'poll'});
              Application.analyticsProvider.trackEvent('poll_updated', {content: self.poll._id, content_type: 'poll', title: self.poll.title});
              self.poll = data;
              self.info.states.push(JSON.parse(JSON.stringify(data)));
              if (expirationUpdate) {
                self.info.timeFormatting();
              }
              Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['editPoll.changes_saved']});
              self.info.updateIndicator = false;
            }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['editPoll.unable_to_save_poll'], duration: 5});
          self.info.updateIndicator = false;
        });
      },
      publish: function() {
        this.save({published: true})
            .then(function() {
              self.info.promptPublish = false;
              $translate('editPoll.poll_was_published', {title: self.poll.title}).then(function(translation) {
                Application.messaging.addMessage({type: 'success', duration: 5, text: translation});
                Application.navigation.goTo('/overview/polls');
              });
            });
      },
      archive: function() {
        self.info.updateIndicator = true;
        Viewables.archive({content: [{id: self.poll._id, type: 'poll'}]}).$promise
            .then(function(results) {
              Application.messaging.addMessage({type: 'success', text: self.translations['editPoll.poll_was_archived'], duration: 5});
              Analyze.record({resource: 'deletions'}, {document: self.poll._id, type: 'poll'});
              Application.analyticsProvider.trackEvent('poll_deleted', {content: self.poll._id, content_type: 'poll', title: self.poll.title});
              Application.navigation.goTo('/admin/content');
              self.info.updateIndicator = false;
              self.info.showArchive = false;
            }).catch(function(err) {
          self.info.updateIndicator = false;
          self.info.showArchive = false;
          Application.messaging.addMessage({type: 'error', text: self.translations['editPoll.issue_removing_this_article'], duration: 5});
        });
      }
    };

    var watchDate = function() {
      $scope.$watch('poll.info.expirationDate', function(newVal, oldVal) {
        if (newVal && !self.info.initializing) {
          self.comms.blurSave('expiration');
        }
      });
    };

    $translate([
      'edit.general.notification_fieldsMissing',
      'edit.general.notification_titleMissing',
      'edit.general.notification_confirmLeave',
      'modules.notifications.article_createdPt1',
      'modules.notifications.article_createdPt2',
      'modules.notifications.article_savedPt1',
      'modules.notifications.article_savedPt2',
      'modules.notifications.article_removed',
      'modules.notifications.unableToFindArticle',
      'modules.notifications.articleNotEditable',
      'editPoll.unable_to_find_poll',
      'editPoll.poll_was_created',
      'editPoll.unable_to_create',
      'editPoll.changes_saved',
      'editPoll.unable_to_save_poll',
      'editPoll.poll_was_published',
      'editPoll.poll_was_archived',
      'editPoll.issue_removing_this_article'
    ]).then(function(translations) {
      self.translations = translations;
      self.comms.initialize();
    });
  }]);